import { elements } from "constants/types";
import { showErrorModal } from "slices/app/actions/error";
import localhost from "apis/localhost";
import {
  setDataPrevLength,
  canLoadContent,
  setContentData,
  setLoading,
} from "slices/discovery/discoverySlice";

export const getContent = (docList) => async (dispatch, getState) => {
  dispatch(setLoading({ element: elements.CONTENT, loading: true }));
  dispatch(setDataPrevLength());

  await localhost
    .post(`/docs/discovery/termInstances`, {
      docSetId: getState().discovery.config.folderId,
      docList,
    })
    .then((response) => {
      const { data } = response;
      dispatch(canLoadContent(false));
      dispatch(setContentData(data));
    })
    .catch((error) => {
      if (error.status !== 200) {
        dispatch(showErrorModal(error));
      }
    })
    .finally(() => {
      dispatch(setLoading({ element: elements.CONTENT, loading: false }));
    });
};
